import type { ActionFunction } from '@remix-run/node';
import { json } from '@remix-run/node';
import invariant from 'tiny-invariant';

import type {
    ResendInviteMutation,
    ResendInviteMutationVariables,
} from 'generated/graphql';
import { ResendInviteDocument } from 'generated/graphql';

export const RESEND_BUILD_HUB_COLLABORATOR_API_ROUTE =
    '/remix-api/app/build-hub-collaborator-resend';

const DEFAULT_FAILED_MESSAGE =
    'Failed to send BuildHub invite to collaborator.';

export const action: ActionFunction = async ({ request, context }) => {
    const data = await request.formData();

    const collaboratorID = data.get('collaboratorID');
    invariant(collaboratorID, 'No Collaborator ID provided for invite resend.');

    const variables: ResendInviteMutationVariables = {
        CollaboratorID: collaboratorID as string,
    };

    try {
        const { data: result } = await context.client.mutate<
            ResendInviteMutation,
            ResendInviteMutationVariables
        >({
            mutation: ResendInviteDocument,
            variables,
        });

        const validResult = result?.buildHubInviteResend;
        if (!validResult) {
            return json({
                buildHubUpsert: {
                    __typename: 'ServerError',
                    Message: DEFAULT_FAILED_MESSAGE,
                },
            });
        }

        return json(result);
    } catch (error) {
        return json({
            buildHubUpsert: {
                __typename: 'ServerError',
                Message:
                    error instanceof Error
                        ? error.message
                        : DEFAULT_FAILED_MESSAGE,
            },
        });
    }
};
